export const LIST = "LIST";
export const UPLOAD = "UPLOAD";
export const DOWNLOAD = "DOWNLOAD";
export const UPDATE_STATUS = "UPDATE_STATUS";